(() => {
  if (window.alesSlideshowPlayback) return;
  window.alesSlideshowPlayback = true;
  const instances = new WeakMap();
  function init(root) {
    if (instances.has(root)) return;
    const track = root.querySelector('[data-ales-track]');
    const slides = [...root.querySelectorAll('[data-ales-slide]')];
    if (!track || !slides.length) return;
    const controller = new AbortController();
    const on = (el, type, fn, options = {}) => el.addEventListener(type, fn, { ...options, signal: controller.signal });
    const dots = [...root.querySelectorAll('[data-ales-dot]')];
    const playback = root.querySelector('[data-ales-playback]');
    const retry = root.querySelector('[data-ales-retry]');
    const mobile = matchMedia('(max-width: 749px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const autoplay = root.dataset.autoplay === 'true';
    const speed = Number(root.dataset.speed) || 5000;
    let index = 0, timer = null, paused = reduced.matches, hovered = false, visible = true, editing = false, blocked = false;
    let activeVideo = null, generation = 0;
    const layer = () => slides[index].querySelector(mobile.matches ? '.ales-slideshow__layer--mobile' : '.ales-slideshow__layer--desktop');
    const waiting = () => slides[index].dataset.waitForVideo === 'true' && activeVideo;
    const loader = document.getElementById('AlesBrandLoader');
    const loading = () => loader && !loader.hidden;
    const canAdvance = () => !loading() && autoplay && slides.length > 1 && !paused && !hovered && visible && !document.hidden && !editing && !blocked;
    const stop = () => { clearTimeout(timer); timer = null; };
    function buttonState() {
      if (!playback) return;
      playback.setAttribute('aria-label', paused ? playback.dataset.playLabel : playback.dataset.pauseLabel);
      playback.querySelector('[data-ales-playback-icon]').textContent = paused ? '▶' : 'Ⅱ';
    }
    function schedule() {
      stop();
      if (!canAdvance()) return;
      if (waiting()) {
        if (activeVideo.ended) timer = setTimeout(() => setActive(index + 1), 0);
        return;
      }
      timer = setTimeout(() => setActive(index + 1), speed);
    }
    function pauseMedia() {
      root.querySelectorAll('[data-ales-video]').forEach(video => video.pause());
      root.querySelectorAll('[data-ales-iframe]').forEach(frame => frame.removeAttribute('src'));
    }
    function failure(video, token) {
      if (video !== activeVideo || token !== generation) return;
      blocked = true;
      stop();
      retry.hidden = false;
    }
    function play() {
      if (paused || document.hidden || !visible || loading()) return;
      const currentLayer = layer();
      if (activeVideo) {
        if (activeVideo.dataset.alesAutoplay !== 'true' || activeVideo.ended || blocked) return;
        let changed = false;
        activeVideo.querySelectorAll('source[data-src]').forEach(source => {
          if (!source.hasAttribute('src')) { source.src = source.dataset.src; changed = true; }
        });
        if (changed) activeVideo.load();
        const video = activeVideo, token = generation;
        video.play().catch(() => failure(video, token));
      } else {
        currentLayer?.querySelectorAll('[data-ales-iframe]').forEach(frame => {
          if (!frame.hasAttribute('src')) frame.src = frame.dataset.alesEmbed;
        });
      }
    }
    function sync() {
      if (paused || document.hidden || !visible || loading()) { stop(); pauseMedia(); }
      else { play(); schedule(); }
      buttonState();
    }
    function setActive(next) {
      stop();
      generation++;
      pauseMedia();
      index = (next + slides.length) % slides.length;
      root.dataset.activeIndex = String(index);
      track.style.transform = `translateX(${-index * 100}%)`;
      slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== index));
        slide.inert = i !== index;
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', String(i === index));
      });
      blocked = false;
      retry.hidden = true;
      activeVideo = layer()?.querySelector('[data-ales-video]') || null;
      if (activeVideo) {
        if (waiting()) activeVideo.loop = false;
        try { activeVideo.currentTime = 0; } catch (_) {}
      }
      sync();
    }
    root.querySelectorAll('[data-ales-video]').forEach(video => {
      on(video, 'ended', () => { if (video === activeVideo && waiting()) schedule(); });
      on(video, 'error', () => { if (video === activeVideo) failure(video, generation); });
      on(video, 'playing', () => {
        if (video !== activeVideo || paused || document.hidden || !visible) { video.pause(); return; }
        blocked = false;
        retry.hidden = true;
        schedule();
      });
    });
    const next = root.querySelector('[data-ales-next]'), prev = root.querySelector('[data-ales-prev]');
    if (next) on(next, 'click', () => setActive(index + 1));
    if (prev) on(prev, 'click', () => setActive(index - 1));
    dots.forEach(dot => on(dot, 'click', () => setActive(Number(dot.dataset.index))));
    if (playback) on(playback, 'click', () => { paused = !paused; sync(); });
    on(retry, 'click', () => {
      paused = false; blocked = false; retry.hidden = true;
      if (activeVideo?.error) activeVideo.load();
      sync();
    });
    let startX = null, startY = null;
    on(root, 'touchstart', event => {
      if (event.target.closest('button, a, video[controls]')) return;
      startX = event.touches[0]?.clientX; startY = event.touches[0]?.clientY;
    }, { passive: true });
    on(root, 'touchend', event => {
      if (startX == null || !event.changedTouches[0]) return;
      const dx = event.changedTouches[0].clientX - startX, dy = event.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) setActive(index + (dx < 0 ? 1 : -1));
    }, { passive: true });
    on(root, 'mouseenter', () => { if (matchMedia('(hover: hover)').matches) { hovered = true; stop(); } });
    on(root, 'mouseleave', () => { hovered = false; schedule(); });
    on(document, 'visibilitychange', sync);
    const loaderObserver = new MutationObserver(sync);
    if (loader) loaderObserver.observe(loader, { attributes: true, attributeFilter: ['hidden'] });
    on(mobile, 'change', () => setActive(index));
    on(reduced, 'change', () => { paused = reduced.matches; sync(); });
    on(root, 'shopify:block:select', event => {
      const slide = event.target.closest('[data-ales-slide]');
      if (slide) { editing = true; setActive(slides.indexOf(slide)); }
    });
    on(root, 'shopify:block:deselect', () => { editing = false; schedule(); });
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: 0 });
    observer.observe(root);
    instances.set(root, () => { generation++; stop(); pauseMedia(); observer.disconnect(); loaderObserver.disconnect(); controller.abort(); instances.delete(root); });
    setActive(0);
  }
  const mount = scope => {
    if (scope.matches?.('[data-ales-slideshow]')) init(scope);
    scope.querySelectorAll('[data-ales-slideshow]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ales-slideshow]').forEach(root => instances.get(root)?.()));
})();
